export const fuelHistoryState = (fleetId) => ({
  fleetId,
  startDate: null,
  endDate: null,
  searchKey: "",
  productCode: "all",
  page: 1,
  perPage: 10,
});
